exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".options-menu__item{min-height:60px}.options-menu__item span{font-size:16px;font-size:1rem}.options-menu__item .rc-menu-submenu-title{min-height:60px}.options-menu__item--selected{background-color:rgba(0,0,0,0.08)}\n", ""]);

// exports
exports.locals = {
	"options-menu__item": "options-menu__item",
	"rc-menu-submenu-title": "rc-menu-submenu-title",
	"options-menu__item--selected": "options-menu__item--selected"
};